import React from "react";
import { Link } from "react-router-dom";

export default function Button({
  text,
  children,
  to,
  href,
  onClick,
  className = "",
  variant = "primary",
  type = "button",
  disabled = false,
  ...rest
}) {
  const content = children ?? text;
  const variantClass = variant === "outline" ? "btn-outline" : "btn-primary";
  const cls = `${variantClass} ${className}`.trim();

  if (to) {
    return (
      <Link to={to} className={cls} {...rest}>
        {content}
      </Link>
    );
  }

  if (href) {
    return (
      <a href={href} className={cls} {...rest}>
        {content}
      </a>
    );
  }

  return (
    <button
      type={type}
      onClick={onClick}
      className={cls}
      disabled={disabled}
      {...rest}
    >
      {content}
    </button>
  );
}